@if ({ violations: violations$ | async }; as STATE) {
  <article class="ads-type-creation-form">
    <custom-modal-card>
      <ng-container header>
        <default-modal-header
          [title]="
            adsType()?.id ? 'Modifier un type' : 'Créer un type de publicité'
          "
          [description]="
            adsType()?.id
              ? 'Renseigner le champ ci-dessous pour la modification d\'un type'
              : 'Renseigner le champ ci-dessous pour la création d\'un nouveau type'
          "
        ></default-modal-header>
      </ng-container>
      <ng-container body>
        <form [formGroup]="form" (ngSubmit)="onSubmit()" class="resource-form">
          <article>
            <mat-label>Nom du type de publicité *</mat-label>
            <mat-form-field color="primary">
              <input formControlName="name" matInput placeholder="Spot" />
            </mat-form-field>
            <mat-error
              *ngIf="$any(form.get('name'))?.getError('httpError') as httpError"
            >
              <strong>{{ httpError }}</strong>
            </mat-error>
          </article>
          <article>
            <mat-label>Média *</mat-label>
            <mat-form-field>
              <mat-select
                formControlName="mediaType"
                placeholder="Sélectionner un média"
              >
                @for (mediaType of medias | keyvalue; track mediaType) {
                  <mat-option [value]="mediaType.key">{{
                    mediaType.value
                  }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </article>
          <button
            type="submit"
            [loading]="isSubmitting()"
            [disabled]="!form.valid || isSubmitting()"
            button
          >
            Enregistrer
          </button>
        </form>
      </ng-container>
    </custom-modal-card>
  </article>
}
